export default __webpack_public_path__ + "static/media/mw.33e950c6.svg";